import React, { useContext } from "react";
import { CustomerGoalsContext } from "../../context/CustomerGoalsContext";
import { getValue } from "../../utils";

const CustomerGoalForm = ({ handleCancel, handleCallback }) => {
  const { customer_goal, setPropertyCustomerGoal, saveCustomerGoal } =
    useContext(CustomerGoalsContext);

  const handleSubmit = (e) => {
    e.preventDefault();
    saveCustomerGoal(customer_goal, handleCallback);
  };
  return (
    <form onSubmit={handleSubmit}>
      <label>Nombre</label>
      <input
        type="text"
        value={getValue(customer_goal, "name")}
        className="form-control mb-3"
        onChange={(e) => setPropertyCustomerGoal("name", e.target.value)}
      />
      <div className="row">
        <div className="col-6">
          <button
            type="button"
            onClick={handleCancel}
            className="btn w-100 text-muted"
          >
            Cancelar
          </button>
        </div>
        <div className="col-6">
          <button type="submit" className="btn w-100 btn-primary">
            Guardar
          </button>
        </div>
      </div>
    </form>
  );
};

export default CustomerGoalForm;
